import state from "./modulePassengerState.js";
import mutations from "./modulePassengerMutations.js";
import actions from "./modulePassengerActions.js";
import getters from "./modulePassengerGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
